<template>
  <div class="events-page container homebase-container pt-5 pb-5">
    <div><back-to-home-button /></div>
    <event-feed
      title="Autodesk Event Calendar"
      :events="events"
      :topics="topics"
      :calendarEvents="calendarEvents"
      :is-loading="isLoading"
      :is-errored="isErrored"
      :show-load-more="showLoadMore"
      :is-more-loading="isMoreLoading"
      @onLoadMore="handleLoadMoreClicked"
      @interestsSaved="resetEventsFeed">
    </event-feed>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
import BackToHomeButton from "@/components/homebase/buttons/BackToHomeButton";
import EventFeed from "./../eventsByInterests/EventFeed";

export default {
  name: "events-page",
  components: {
    BackToHomeButton,
    EventFeed
  },
  data() {
    return {
      isLoading: true,
      isMoreLoading: false,
      isErrored: false,
      events: [],
      calendarEvents: [],
      topics: null,
      // pagination
      currentPage: 1,
      currentMonth: "",
      pageCount: 1,
      pageSize: 10,
      showLoadMore: false
    };
  },
  created() {
    this.initializeEventsByInterests();
  },
  methods: {
    async initializeEventsByInterests() {
      await this.getEvents();
    },
    async getEvents() {
      this.setIsLoading(true);
      try {
        let offset = this.getQueryOffset();
        let eventsRes = await api.getEventsByInterest(offset,this.pageSize);
        let eventsArray = eventsRes.data.data.eventsByInterest.events.events;
        
        if(eventsArray) {
          this.setMonthHeader(eventsArray);
          this.events = this.events.concat(eventsArray);
          this.calendarEvents = await this.getUserCalendarEvents();
        }
        
        this.topics = eventsRes.data.data.eventsByInterest.topics;
        let total = eventsRes.data.data.eventsByInterest.events.total;
        this.setPaginationConfig(total);
      } catch (e) {
        console.log(e);
        this.isErrored = true;
      } finally {
        this.setIsLoading(false);
      }
    },
    async getUserCalendarEvents() {
      const calendarEvents = await api.getUserCalendarEvents();
      return calendarEvents.data.data.getUserCalendarEvents;
    },
    async resetEventsFeed() {
      this.events = [];
      this.topics = null;
      this.pageCount = 1;
      this.currentPage = 1;
      await this.getEvents();
    },
    setMonthHeader(events) {
      events.forEach((event) => {
        const eventDate = moment.utc(event.startDate);
        if(eventDate.format('MMMM') !== this.currentMonth) {
          this.currentMonth = eventDate.format('MMMM');
          event.monthHeader = this.currentMonth;
        }
      });
    },
    getQueryOffset() {
      let offset = (this.currentPage - 1) * this.pageSize;
      return offset;
    },
    setPaginationConfig(total) {
      this.pageCount = Math.ceil(total / this.pageSize);
      this.setShowLoadMore(total);
    },
    setShowLoadMore(total) {
      this.showLoadMore = this.currentPage * this.pageSize < total;
    },
    setIsLoading(value) {
      if (this.currentPage == 1) {
        this.isLoading = value;
      } else {
        this.isMoreLoading = value;
      }
    },
    async handleLoadMoreClicked() {
      ++this.currentPage;
      await this.getEvents();
    }
  }
};
</script>

<style scoped src="../../../../static/aone-theme.css"></style>
<style scoped>
.events-page {
  min-height: 600px;
}
.load-more-wrapper {
  margin-top: 30px;
}
.more-loading-spinner img {
  height: 50px;
}

</style>